/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationEventResponse } from './IntegrationEventResponse';
import {
    IntegrationEventResponseFromJSON,
    IntegrationEventResponseFromJSONTyped,
    IntegrationEventResponseToJSON,
} from './IntegrationEventResponse';

/**
 * 
 * @export
 * @interface FindAllIntegrationEventsByFacilityId200Response
 */
export interface FindAllIntegrationEventsByFacilityId200Response {
    /**
     * 
     * @type {IntegrationEventResponse}
     * @memberof FindAllIntegrationEventsByFacilityId200Response
     */
    data?: IntegrationEventResponse;
}

/**
 * Check if a given object implements the FindAllIntegrationEventsByFacilityId200Response interface.
 */
export function instanceOfFindAllIntegrationEventsByFacilityId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllIntegrationEventsByFacilityId200ResponseFromJSON(json: any): FindAllIntegrationEventsByFacilityId200Response {
    return FindAllIntegrationEventsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllIntegrationEventsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIntegrationEventsByFacilityId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : IntegrationEventResponseFromJSON(json['data']),
    };
}

export function FindAllIntegrationEventsByFacilityId200ResponseToJSON(value?: FindAllIntegrationEventsByFacilityId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': IntegrationEventResponseToJSON(value.data),
    };
}

